import React from 'react';

function TemplateControlDocs(props) {

    return (
        <div id="template-controldocs">
            {props.children}
        </div>
    );
}
export default TemplateControlDocs;
